import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchIDF = createAsyncThunk(
    'cargo/fetchIDF',
    async (payload, { rejectWithValue }) => {
        try {
            const requestData = typeof payload === 'string'
                ? { idf_number: payload, agents_company_pin: '' }
                : payload;
            const { data } = await api.post('/cargo/idf-lookup', requestData);
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'IDF lookup failed');
        }
    }
);

export const generateQuotations = createAsyncThunk(
    'cargo/generateQuotations',
    async (payload, { rejectWithValue }) => {
        try {
            console.log('[generateQuotations] Sending payload...');
            const { data } = await api.post('/cargo/quotations', payload);
            console.log('[generateQuotations] Raw response:', data);

            // Backend returns { quotations: [...], idfNumber: '...' }
            const quotations = data?.quotations || [];
            console.log('[generateQuotations] Extracted', quotations.length, 'quotations');
            return quotations;
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Failed to generate quotations');
        }
    }
);

export const acceptQuotation = createAsyncThunk(
    'cargo/acceptQuotation',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await api.post('/cargo/quotations/accept', payload);
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Acceptance failed');
        }
    }
);

export const submitForApproval = createAsyncThunk(
    'cargo/submitForApproval',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await api.post('/cargo/quotations/submit-for-approval', payload);
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Submission failed');
        }
    }
);

const initialState = {
    idfData: null,
    quotations: [],
    selectedQuote: null,
    acceptance: null,
    payment: null,
    certificate: null,
    loading: {
        idf: false,
        quotations: false,
        acceptance: false,
        payment: false,
        certificate: false,
    },
    error: {
        idf: null,
        quotations: null,
        acceptance: null,
        payment: null,
        certificate: null,
    },
};

const cargoSlice = createSlice({
    name: 'cargo',
    initialState,
    reducers: {
        setSelectedQuote: (state, action) => { state.selectedQuote = action.payload; },
        setStepData: (state, action) => { Object.assign(state, action.payload); },
        resetCargo: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchIDF.pending, (state) => { state.loading.idf = true; state.error.idf = null; })
            .addCase(fetchIDF.fulfilled, (state, action) => {
                state.loading.idf = false;
                state.idfData = action.payload;
                console.log('[cargoSlice] IDF data stored');
            })
            .addCase(fetchIDF.rejected, (state, action) => { state.loading.idf = false; state.error.idf = action.payload; })

            .addCase(generateQuotations.pending, (state) => {
                state.loading.quotations = true;
                state.error.quotations = null;
                console.log('[cargoSlice] Loading quotations...');
            })
            .addCase(generateQuotations.fulfilled, (state, action) => {
                state.loading.quotations = false;
                state.quotations = Array.isArray(action.payload) ? action.payload : [];
                console.log('[cargoSlice] Stored', state.quotations.length, 'quotations:', state.quotations);
            })
            .addCase(generateQuotations.rejected, (state, action) => {
                state.loading.quotations = false;
                state.error.quotations = action.payload;
                console.log('[cargoSlice] Error:', action.payload);
            })

            .addCase(acceptQuotation.pending, (state) => { state.loading.acceptance = true; state.error.acceptance = null; })
            .addCase(acceptQuotation.fulfilled, (state, action) => { state.loading.acceptance = false; state.acceptance = action.payload; })
            .addCase(acceptQuotation.rejected, (state, action) => { state.loading.acceptance = false; state.error.acceptance = action.payload; })

            .addCase(submitForApproval.pending, (state) => { state.loading.acceptance = true; state.error.acceptance = null; })
            .addCase(submitForApproval.fulfilled, (state, action) => { state.loading.acceptance = false; state.acceptance = action.payload; })
            .addCase(submitForApproval.rejected, (state, action) => { state.loading.acceptance = false; state.error.acceptance = action.payload; });
    },
});

export const { setSelectedQuote, setStepData, resetCargo } = cargoSlice.actions;
export default cargoSlice.reducer;